export default "__VITE_ASSET__DKEK7PcJ__"